import DemoPage from "./demo.jsx";

export default function DemoNo() {
  return <DemoPage forcedLang="no" />;
}